<div>
  <div class="page-wrapper">
    <!-- ============================================================== -->
    <!-- Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->

    <div class="container-fluid">
      <div class="row">
        <!-- Column -->
        <div class="col-sm-12" style="margin-top: -30px">
          <div class="card" style="border: none;">
            <div class="card-body" style="padding:0.2rem">
              <div class="form-vertical form-material mx-2">
                <div class="row">
                  <div class="col-md-12 col-lg-2 col-xs-12 col-sm-12 padding-remove date-picker-size">
                    <div class="form-group mt-2">
                      <label for="Date Opened" class="col-md-12 padding-remove">From Date</label>
                      <div class="col-md-12 padding-remove input-group">
                    
                        <input 
                          type="text" 
                          placeholder="dd-mm-yyyy" 
                          class="form-control ps-0 form-control-line" 
                          id="FromDate"
                          name="fromDate"
                          [(ngModel)]="fromDateModel"
                          (dateSelect)="fromdatechange($event)"
                          ngbDatepicker
                          #d="ngbDatepicker"
                          [container]="'body'" />  <!--  <-- ADD THIS LINE -->
                    
                        <div class="input-group-addon">
                          <!-- <button class="btn btn-outline-secondary" (click)="d.toggle()" type="button"> -->
                            <i class="fa fa-calendar icon1" (click)="d.toggle()"></i>
                          <!-- </button> -->
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 col-lg-2 col-xs-12 col-sm-12 padding-remove date-picker-size">
                    <!-- <div class="form-group mt-2">
                      <label for="Date Opened" class="col-md-12 padding-remove">To Date</label>
                      <div class="col-md-12 padding-remove input-group date datefrom" data-provide="datepicker">
                        <input [disabled]="isBranchUser == '1'" type="text" placeholder="dd-mm-yyyy"
                          class="form-control" data-date-format="dd-mm-yyyy" id="ToDate" />
                        <div class="input-group-addon">
                          <i class="fa fa-calendar icon1"></i>
                        </div>
                      </div>
                    </div> -->
                    <div class="form-group mt-2">
                      <label for="ToDate" class="col-md-12 padding-remove">To Date</label>
                      <div class="col-md-12 padding-remove input-group">
                          <!--
                            This input is bound to `toDateModel`.
                            Its value will be updated automatically when you select a "From Date".
                          -->
                          <input 
                              type="text" 
                              placeholder="dd-mm-yyyy" 
                              class="form-control ps-0 form-control-line" 
                              id="ToDate"
                              name="toDate"
                              [(ngModel)]="toDateModel"
                              ngbDatepicker
                              [container]="'body'" />
                          <div class="input-group-addon">
                              <!-- <button class="btn btn-outline-secondary" (click)="dTo.toggle()" type="button"> -->
                                  <i class="fa fa-calendar icon1"></i>
                              <!-- </button> -->
                          </div>
                      </div>
                  </div>
                  </div>
                  <div class="col-md-12 col-lg-1 col-xs-12 col-sm-12 filter-size" >
                    <div class="form-group mt-2">
                      <label for="issueinput4" class="col-md-12">SID/Visit No</label>
                      <div class="col-md-12">
                        <input type="text" placeholder="Enter SID Number" name="SID" [(ngModel)]="SIDNo"
                          class="form-control ps-0 form-control-line">
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 col-lg-2 col-xs-12 col-sm-12">
                    <div class="form-group mt-2">
                      <label for="issueinput4" class="col-md-12">Patient
                        Name</label>
                      <div class="col-md-12">
                        <input type="text" placeholder="Enter Patient Name" [(ngModel)]="PatientName"
                          class="form-control ps-0 form-control-line">
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 col-lg-1 col-xs-12 col-sm-12 filter-size">
                    <div class="form-group mt-2">
                      <label for="issueinput4" class="col-md-12">Client Reference No
                      </label>
                      <div class="col-md-12">
                        <input type="text" placeholder="Enter Client Ref No" [(ngModel)]="Client_Ref_No"
                          class="form-control ps-0 form-control-line">
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 col-lg-2 col-xs-12 col-sm-12">
                    <div class="form-group mt-2">
                      <label for="issueinput4" class="col-md-12">Branch/Referrer Name</label>
                      <div class="col-md-12">
                        <select name="city" class="form-select shadow-none border-0 ps-0 form-control-line"
                          placeholder="Branch" [(ngModel)]="BranchCode">
                          <option value="ALL">ALL</option>
                          <option *ngFor="let branch of locations" [value]="branch.FirmNo">
                            {{ branch.FirmName }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 col-lg-1 col-xs-12 col-sm-12 button-size-design" >
                    <div class="ext-end upgrade-btn">
                      <button type="button" class="btn btn-success d-md-inline-block text-white mt-3"
                        (click)="FetchData()" (keydown.enter)="FetchData()">
                        Fetch
                      </button>

                      <button type="reset" class="btn btn-danger d-md-inline-block text-white ml-2 mt-3" id="reset-btn"
                        (click)="reset()" value="reset">
                        Reset
                      </button>
                    </div>
                  </div>
                  <!-- </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Column -->
        <!-- Column -->
        <!-- Column -->
      </div>

      <!-- ============================================================== -->
      <!-- Sales chart -->
      <!-- ============================================================== -->

      <!-- ============================================================== -->
      <!-- Sales chart -->
      <!-- ============================================================== -->

      <!-- ============================================================== -->
      <!-- Table -->
      <!-- ============================================================== -->

      <!-- <section id="extended"> -->
      <div class="row">
        <div class="col-sm-12" style="margin-top: -15px">
          <div class="card" style="border: none;border-radius: 5px;">
            <div class="card-content">
              <div class="card-body" style="padding: 0.7rem">
                <div class="d-md-flex">
                  <h4 class="card-title col-md-10 mb-md-0 mb-3 align-self-center">Organisational
                    Report</h4>
                  <!-- <li class="nav-item hidden-sm-down"> -->
                  <div class="app-search">
                    <input type="text" class="form-control" [(ngModel)]="searchText" placeholder="Search in Browser"
                      style="width: 230px;" />
                    <a class="srh-btn"><i class="ti-search"></i></a>
                  </div>
                  <!-- </li> -->
                </div>
                <div class="table-responsive mt-2">
                  <table class="table stylish-table no-wrap">
                    <thead>
                      <tr>
                        <th class="maxscreenalign border-top-0">S.No</th>
                        <th class="border-top-0 text-center">Branch Name</th>
                        <th class="maxscreenalign border-top-0">SID/Visit No</th>
                        <th class="border-top-0 text-center">Visited Date</th>
                        <th class="border-top-0"  style="position: relative;left: 2%;width: 200px;">Patient Name</th>
                        <th class="maxscreenalign border-top-0">Client Reference No</th>
                        <th class="border-top-0 text-center">Patient Age</th>
                        <th class="border-top-0 text-center">Patient Gender</th>
                        <th class="border-top-0 text-center">Referrer Code</th>
                        <th class="border-top-0 text-center">Report Status</th>
                        <th class="maxscreenalign border-top-0">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of patients | search: searchText;let i = index">
                        <td class="maxscreenalign align-middle">
                          <span class="snoresponse">{{ i + 1 }}</span>
                        </td>
                        <td class="align-middle  text-center">
                          <small class="text-muted text-uppercase">{{ item.Branch_Desc }}</small>
                        </td>
                        <td class="maxscreenalign align-middle text-center">{{ item.Sid_No }}</td>
                        <td class="align-middle text-center">{{ item.Sid_Date_Formatted }}</td>
                        <td class="align-middle" style="position: relative;
                        left: 2%;">
                          <small class="text-muted">{{ item.PName }}</small>
                        </td>
                        <td class="maxscreenalign align-middle text-center">{{ item.Client_Ref_No ? item.Client_Ref_No : '-' }}</td>
                        <td class="maxscreenalign align-middle text-center">{{ item.Age }}</td>
                        <td class="align-middle text-center">{{ item.sex }}</td>
                        <td class="align-middle text-center">
                          <small class="text-muted">{{ item.RefCode }}</small>
                        </td>
                        <td *ngIf="item.ReportStatus == 'Partially Completed'"
                          class="StatusField hyper_span align-middle text-center">
                          <button class="btn-partially mx-auto mx-md-0 text-white" style="cursor:none">
                            {{ item.ReportStatus }}</button>
                        </td>

                        <td *ngIf="item.ReportStatus == 'Pending/Cancelled' "
                          class="StatusField hyper_span align-middle text-center">
                          <button class="btn-pending mx-auto mx-md-0 text-white" style="cursor:none">
                            {{ item.ReportStatus }}</button>
                        </td>
                        <td
                          *ngIf=" item.ReportStatus != 'Pending/Cancelled' && item.ReportStatus != 'Partially Completed'"
                          class="StatusField hyper_span align-middle text-center">
                          <button class="btn-completed mx-auto mx-md-0 text-white" style="cursor:none">{{
                            item.ReportStatus }}</button>
                        </td>
                        <td class="maxscreenalign align-middle" style="position: relative;
                        top: -5px;">
                          <a class="sidebar-link waves-effect waves-dark sidebar-link viewresponce">
                            <button type="button" class="btn btn-success" (click)="
                      PatientTimeLine(item.Mobile, item.Pt_Code, item.PName,item.Client_Ref_No)">View
                            </button></a>
                        </td>
                      </tr>
                      <br />
                      <tr *ngIf="!patients?.length">
                        <td colspan="10">No Records Found...</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- ============================================================== -->
        <!-- Table -->
        <!-- ============================================================== -->
        <!-- ============================================================== -->
        <!-- Recent blogss -->
        <!-- ============================================================== -->

        <!-- ============================================================== -->
        <!-- Recent blogss -->
        <!-- ============================================================== -->
      </div>
      <!-- ============================================================== -->
      <!-- End Container fluid  -->
      <!-- ============================================================== -->
      <!-- ============================================================== -->
    </div>
  </div>

  <!-- ============================================================== -->
  <!-- End Page wrapper  -->
  <!-- ============================================================== -->
  <!-- footer -->
  <!-- ============================================================== -->
  <!-- <footer class="footer">
  </footer> -->
  <!-- ============================================================== -->
  <!-- End footer -->
  <!-- ============================================================== -->





  <!-- </section> -->
  <!-- <div id="overlay" class="overlay ajaxOverlay"></div>
<div id="spinner" class="spinner ajaxOverlay"></div> -->
  <div id="pageoverlay" class="pageoverlay ajaxOverlay"></div>
  <div id="pagespinner" class="pagespinner ajaxOverlay"></div>